export const SEARCH_TYPE__STARTS_WITH = 'starts-with';
